import React from 'react';

import { Box } from '@mui/material';

import DemoButton from './RibbonComponents/DemoButton';
import SubscriptionPlanChip from './RibbonComponents/SubscriptionPlanChip';
import HelpMenu from './RibbonComponents/HelpMenu';
import UserMenu from './RibbonComponents/UserMenu';
import SearchButton from './RibbonComponents/SearchButton';

const Ribbon = ({
  isMobile,
  setIsMobileSearchBarOpen,
  logoutThunk,
  setCurrency,
  user,
  currency,
  setLoginModalOpen,
  dashboardState,
  handleMarketSidebarClick,
  setSubscriptionModalOpen,
  handleSidebarListItemClick,
  centerCoord,
  address,
  openDemoBookingForm,
  setDemoFormHeadingFor,
  dummyMarket,
  isMarketDashboard,
}) => {
  const currentPath = window.location.pathname;
  const isDemoMarket =
    currentPath.includes('/airbnb-data') &&
    !currentPath.includes(
      `/airbnb-data/${dummyMarket?.country}/${dummyMarket?.city}/${dummyMarket?.district}`
    );

  return (
    <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
      {!isMobile && isDemoMarket && <DemoButton dummyMarket={dummyMarket} />}
      {!isMobile && (
        <SubscriptionPlanChip
          dashboardState={dashboardState}
          setSubscriptionModalOpen={setSubscriptionModalOpen}
          address={address}
          centerCoord={centerCoord}
          setLoginModalOpen={setLoginModalOpen}
        />
      )}
      {isMobile && isMarketDashboard && (
        <SearchButton setIsMobileSearchBarOpen={setIsMobileSearchBarOpen} />
      )}
      <HelpMenu
        handleMarketSidebarClick={handleMarketSidebarClick}
        handleSidebarListItemClick={handleSidebarListItemClick}
        openDemoBookingForm={openDemoBookingForm}
        setDemoFormHeadingFor={setDemoFormHeadingFor}
      />
      <UserMenu
        logoutThunk={logoutThunk}
        user={user}
        handleMarketSidebarClick={handleMarketSidebarClick}
        currency={currency}
        setCurrency={setCurrency}
        setLoginModalOpen={setLoginModalOpen}
        centerCoord={centerCoord}
        address={address}
      />
    </Box>
  );
};

export default Ribbon;
